module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.dados) ? _c('div', {
    staticClass: "wrapper-md dados-container"
  }, [_c('div', {
    staticClass: "dados"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Total de Cadastros")]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm._f("number")(_vm.dados.total)))])]), _vm._v(" "), _c('div', {
    staticClass: "dados"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Incompletos")]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm._f("number")(_vm.dados.incompletos)))])]), _vm._v(" "), _c('div', {
    staticClass: "dados"
  }, [_c('a', {
    attrs: {
      "href": "/#/website/arrematantes/aprovacao",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Pendentes para Aprovação")]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm._f("number")(_vm.dados.pendentesAprovacao)))])])]), _vm._v(" "), _c('div', {
    staticClass: "dados"
  }, [_c('div', {
    staticClass: "title text-primary"
  }, [_vm._v("Não Aprovados")]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm._f("number")(_vm.dados.naoAprovados)))])]), _vm._v(" "), _c('div', {
    staticClass: "dados"
  }, [_c('div', {
    staticClass: "title text-danger"
  }, [_vm._v("Bloqueados")]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm._f("number")(_vm.dados.bloqueados)))])]), _vm._v(" "), _c('div', {
    staticClass: "dados"
  }, [_c('div', {
    staticClass: "title text-success"
  }, [_vm._v("Aprovados")]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm._f("number")(_vm.dados.aprovados)))])]), _vm._v(" "), _c('div', {
    staticClass: "dados"
  }, [_c('div', {
    staticClass: "title text-success"
  }, [_vm._v("Aprovados Ontem")]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm._f("number")(_vm.dados.aprovadosOntem)))])]), _vm._v(" "), _c('div', {
    staticClass: "dados"
  }, [_c('div', {
    staticClass: "title text-success"
  }, [_vm._v("Analisados Hoje")]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm._f("number")(_vm.dados.analisesHoje)))])]), _vm._v(" "), _c('div', {
    staticClass: "dados"
  }, [_c('div', {
    staticClass: "title text-success"
  }, [_vm._v("Aprovados Hoje")]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm._f("number")(_vm.dados.aprovadosHoje)))])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dc641070","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/arematantes/components/EstatisticaCadastro.vue
// module id = 864
// module chunks = 2